/// <reference types="vite-plugin-svgr/client" />
import { keyBy } from "lodash";

import { ReactComponent as WarmAndComforting } from "../../../assets/images/cuisine/WarmAndComforting.svg";
import { ReactComponent as CafeStyle } from "../../../assets/images/cuisine/CafeStyle.svg";
import { ReactComponent as LightAndFresh } from "../../../assets/images/cuisine/LightAndFresh.svg";
import { ReactComponent as QuickAndGreasy } from "../../../assets/images/cuisine/QuickAndGreasy.svg";
import { ReactComponent as HungryBeast } from "../../../assets/images/cuisine/HungryBeast.svg";
import { ReactComponent as NoodlesAndRice } from "../../../assets/images/cuisine/NoodlesAndRice.svg";
import { ReactComponent as TreatingMyself } from "../../../assets/images/cuisine/TreatingMyself.svg";
import { ReactComponent as Sweet } from "../../../assets/images/cuisine/Sweet.svg";
import { ReactComponent as Drinks } from "../../../assets/images/cuisine/Drinks.svg";

import { ReactComponent as Vegan } from "../../../assets/images/dietaries/Vegan.svg";
import { ReactComponent as Vegetarian } from "../../../assets/images/dietaries/Vegetarian.svg";
import { ReactComponent as DairyFree } from "../../../assets/images/dietaries/DairyFree.svg";
import { ReactComponent as GlutenFree } from "../../../assets/images/dietaries/GlutenFree.svg";
import { ReactComponent as FODMAP } from "../../../assets/images/dietaries/FODMAP.svg";
import { ReactComponent as NutFree } from "../../../assets/images/dietaries/NutFree.svg";
import { ReactComponent as Halal } from "../../../assets/images/dietaries/Halal.svg";
import { ReactComponent as Kosher } from "../../../assets/images/dietaries/Kosher.svg";

export const Cravings = [
  { value: "warm_and_comforting", Icon: WarmAndComforting },
  { value: "cafe_style", Icon: CafeStyle },
  { value: "light_and_fresh", Icon: LightAndFresh },
  { value: "quick_and_greasy", Icon: QuickAndGreasy },
  { value: "hungry_beast", Icon: HungryBeast },
  { value: "noodles_and_rice", Icon: NoodlesAndRice },
  { value: "treating_myself", Icon: TreatingMyself },
  { value: "sweet", Icon: Sweet },
  { value: "drinks", Icon: Drinks },
];
export interface Dietary {
  value: string;
  Icon: NotTypedYet;
}
export const Dietaries: Dietary[] = [
  { value: "vegan", Icon: Vegan },
  { value: "vegetarian", Icon: Vegetarian },
  { value: "dairy_free", Icon: DairyFree },
  { value: "gluten_free", Icon: GlutenFree },
  { value: "fodmap", Icon: FODMAP },
  { value: "nut_free", Icon: NutFree },
  { value: "halal", Icon: Halal },
  { value: "kosher", Icon: Kosher },
];

export const DietaryEntities = keyBy(Dietaries, "value");
export const CravingEntities = keyBy(Cravings, "value");
